<template>
  <div class="version" data-test-id="VersionComponent">v{{ version }}</div>
</template>

<script lang="ts">
import Vue from "vue";
import { version } from "../../../package.json";

export default Vue.extend({
  name: "App",
  components: {},
  data(): any {
    return {
      version,
    };
  },
});
</script>

<style>
.version {
  position: absolute;
  bottom: -5px;
  right: 10px;
  font-size: 80%;
}
</style>
